import { AppLayout } from './components/layout/AppLayout/AppLayout';

export default function App() {
  return <AppLayout />;
}